exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ZmxuW9JbbHlPWnONAE1wD{margin:0 auto;text-align:center;color:#999}.ZmxuW9JbbHlPWnONAE1wD ul{list-style-type:none;margin:0;padding:0}.ZmxuW9JbbHlPWnONAE1wD ul li{display:inline-block;margin:0 5px;padding:0}.ZmxuW9JbbHlPWnONAE1wD a{transition:all 0.25s ease;display:inline-block}.ZmxuW9JbbHlPWnONAE1wD a._18jP9SxDqG5So5YIe2u53y{color:inherit}.ZmxuW9JbbHlPWnONAE1wD a._18jP9SxDqG5So5YIe2u53y:hover{color:#3b5998}.ZmxuW9JbbHlPWnONAE1wD a._2qjFjJQvzE6OM0Ft-fJOUZ{color:inherit}.ZmxuW9JbbHlPWnONAE1wD a._2qjFjJQvzE6OM0Ft-fJOUZ:hover{color:#1da1f2}\n", ""]);

// Exports
exports.locals = {
	"SocialButtons": "ZmxuW9JbbHlPWnONAE1wD",
	"fbLink": "_18jP9SxDqG5So5YIe2u53y",
	"twitterLink": "_2qjFjJQvzE6OM0Ft-fJOUZ"
};